import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWillAdvent from "../../../../src/content/will-graham-advent/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWillAdvent,
  React
};